var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":require("@/assets/images/jh_404.png"),"alt":""}}),_c('p',[_vm._v("您访问的问卷不存在！")])])])
}]

export { render, staticRenderFns }